// Non-fatal warning text describing the sweep's impact when E-Verify is newly
// turned on. Returns null when there's nothing to warn about.
export const getEverifySweepWarning = ({
  isEnabling,
  workersAffected,
  isPreviewFetching,
}: {
  isEnabling: boolean
  workersAffected: number | undefined
  isPreviewFetching: boolean
}): string | null => {
  if (!isEnabling) {
    return null
  }

  const isPreviewReady = !isPreviewFetching && workersAffected !== undefined
  if (!isPreviewReady) {
    return 'Checking impact...'
  }

  if (workersAffected === 0) {
    return 'No currently-scheduled workers will be unscheduled. Unverified workers will still be blocked from accepting future shifts at this company.'
  }

  return `This will unschedule ${workersAffected} currently-scheduled worker(s) who aren't E-Verified from future shifts at this company. They'll be notified.`
}
